import ScatterCh from "./ScatterCh";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { CardTitle } from "../theme/texts";
import NoDataDiv from "../Display/NoDataDiv";
import { Theme } from "../../data/style/Theme";
import { useQuery } from "@tanstack/react-query";
import useScreenSize from "../../context/ScreenContext";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import ExerciseFailedChart from "./ExerciseFailedChart";
import { getWorkoutById } from "../../api/workouts";

const ScoreRangeChart = ({ wodId }) => {
  const { size } = useScreenSize();
  let [width] = size;

  const { data: workout, isPending: isWorkoutPending } = useQuery({
    queryKey: ["workout", parseInt(wodId)],
    queryFn: ({ signal }) => getWorkoutById({ signal, wodId }),
  });

  return (
    <>
      {!isWorkoutPending && (
        <Stack>
          {workout.type === 3 ? (
            <CardTitle
              subTitle={"EMOM analytics"}
              mainTitle={"Exercises athletes failed"}
            />
          ) : (
            <CardTitle subTitle={"Distribution"} mainTitle={"Score Range"} />
          )}
          <Box
            p={1}
            sx={{
              borderRadius: 4,
              border: 1,
              borderColor: Theme.palette.border,
              background: Theme.palette.card,
            }}
            height={"32vh"}
            minHeight={"200px"}
          >
            {workout.isPublic ? (
              <>
                {workout.type === 3 ? (
                  <ExerciseFailedChart workoutId={wodId} />
                ) : (
                  <ScatterCh
                    workoutId={wodId}
                    wod_type={workout.type}
                    wod_rest={workout.rest}
                  />
                )}
              </>
            ) : (
              <NoPublicWorkoutChart width={width} />
            )}
          </Box>
        </Stack>
      )}
    </>
  );
};

export default ScoreRangeChart;

const NoPublicWorkoutChart = ({ width }) => {
  return (
    <NoDataDiv
      icon={
        <LeaderboardIcon
          sx={{
            fontSize: width < 750 ? "3rem" : "4rem",
            color: Theme.palette.orange,
          }}
        />
      }
      height={"100%"}
      text={"Charts are available only in public workouts"}
    />
  );
};
